import { render, staticRenderFns } from "./StatusNew.vue?vue&type=template&id=93e72d4c&scoped=true&"
import script from "./StatusNew.vue?vue&type=script&lang=js&"
export * from "./StatusNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e72d4c",
  null
  
)

export default component.exports